// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3I_gz","paramInput":"JobSimulator_paramInput__2CX3Q","input":"JobSimulator_input__3DkCe"};